let _store: any = null;

export function setStore(storeInstance: any) {
  _store = storeInstance;
}

export function getStore() {
  if (!_store) {
    throw new Error('Store has not been set yet');
  }
  return _store;
}

export type RootState = ReturnType<ReturnType<typeof getStore>['getState']>

